<template>

    <TemplateBasic 
      v-bind:breadcrumb="breadcrumb"
      v-bind:permission="permission">
      
      <AppFilter 
        ref="carparkFilter" 
        filterKey="carparkID"
        v-on:filter-data-change="onFilterCarparkChange" />

      <AppFilter 
        ref="licenseFilter" 
        filterKey="licenseID"
        v-on:filter-data-change="onFilterLicenseChange" />

      <AppFilterDateRange
        ref="dateRangeFilter"
        v-show="showCalendar"
        v-on:filter-data-change="onFilterDateChange" />

      <button v-show="showExportCSV" v-on:click="onCSVButtonClick" type="button" class="btn btn-warning">
        Export CSV
      </button>

      <AppTable 
        ref="pageTable" 
        v-bind:tableParameter="PARAM" 
        v-bind:permission="permission"/>

      <TemplateFeedback class="m-t" ref="pageFeedback" />

    </TemplateBasic>

</template>

<script>
import TemplateBasic from "@/components/Template/TemplateBasic";
import TemplateButton from "@/components/Template/TemplateButton";
import TemplateFeedback from "@/components/Template/TemplateFeedback";
import AppFilterDateRange from "@/components/App/AppFilterDateRange";
import AppSearch from "@/components/App/AppSearch";
import AppPaging from "@/components/App/AppPaging";
import AppFilter from "@/components/App/AppFilter";
import AppTable from "@/components/App/AppTable";
import AppAddButton from "@/components/App/AppAddButton";
import AppForm from "@/components/App/AppForm";
import AppModalForm from "@/components/App/AppModalForm";
import validation from "@/components/Utility/Validation"
import helper from "@/components/Utility/Helper"

var querystring = require('querystring');
var moment = require('moment');

let PARAM = [
  {
    key: '_index',
    index: true,
  },
  {
    key: 'customerType',
    text: 'Type',
  },
  {
    key: 'parkingLicense',
    text: 'Parking License',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      if(dataItem['jt-summary']) return;

      return `<a target="_blank" href="${helper.WEB_URL}/parkinglicenseView?licenseID=${dataItem.licenseID}">${dataItem.parkinglicense}</a>`;
    },
  },
  {
    key: 'customerName',
    text: 'Account Holder',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      if(dataItem['jt-summary']) return;

      if(dataItem.isCompany) {
        return `<a target="_blank" href="${helper.WEB_URL}/companyForm?customerID=${dataItem.customerID}">${dataItem.customer}</a>`;
      } else {
        return `<a target="_blank" href="${helper.WEB_URL}/personalForm?customerID=${dataItem.customerID}">${dataItem.customer}</a>`;
      }
    },
  },
  {
    key: 'customerIdentity',
    text: 'Customer Identity',
  },
  {
    key: 'customerEmail',
    text: 'Email',
  },
  {
    key: 'customerPhone',
    text: 'Phone No. (Mobile)',
  },
  {
    key: 'billType',
    text: 'Bill Type',
  },
  {
    key: 'billNo',
    text: 'Bill No.',
  },
  {
    key: 'billDate',
    text: 'Bill Date',
  },
  {
    key: 'billDescription',
    text: 'Bill Description',
  },
  {
    key: 'inclusive',
    text: 'Amount Inclusive SST (RM)',
  },
  {
    key: 'sst',
    text: '6% SST (RM)',
  },
  {
    key: 'exclusive',
    text: 'Amount Exclusive SST (RM)',
  },
];
const PARAM_MAP = helper.transformParamToMap(PARAM);

export default {
  name: "pageInvoiceCustomerFees",
  components: {
    TemplateBasic,
    TemplateButton,
    AppSearch,
    AppPaging,
    AppFilter,
    AppTable,
    AppAddButton,
    AppForm,
    AppModalForm,
    TemplateFeedback,
    AppFilterDateRange,
  },
  data () {
    return {
      permission : null,
      breadcrumb : [
        { name: 'Home', url: helper.WEB_URL },
        { name: 'Report' },
        { name: 'Outstanding Bills' },
      ],

      PARAM,
      PARAM_MAP,

      pageStaff: [],
      pagePaymentMethod: [],
      pageCarpark: null,
      pageCustomer: null,
      pageBill: null,
      pageSeasonFees: {},
      pageInvoice: null,

      showExportCSV: false,
      showCalendar: false,

      customerContactCache: {},
      invoiceLeaseCache: {},
    }
  },
  mounted() {
    if(!helper.hasViewPermission(this.permission = helper.getPermission(this))) {
      return;
    }
    
    this.$refs['carparkFilter'].formatFilterOptionText = (dataItem) => dataItem.carparkCode ? `${dataItem.carparkCode} - ${dataItem.name}` : dataItem.name;
    this.$refs['licenseFilter'].formatFilterOptionText = option => {
      if(!option.licenseOperatorNum) {
        return 'All Parking Licenses';
      }

      let text = helper.plFormPLNum(option.licenseOperatorNum, option.carparkID);
      let customer = option['_customer'];
      text += customer ? ` ${customer.name} (${customer.nationalID})` : '';
      return text;
    };
    this.$refs['dateRangeFilter'].filterDateStart = moment().startOf('month');
    this.$refs['dateRangeFilter'].filterDateEnd = moment().endOf('month');
    this.loadCarpark();
  },
  methods: {
    loadPaymentMethod() {
      let feedbackItem = 'payment method';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/paymethods/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            this.pagePaymentMethod = response.data;
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.loadCarpark();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No ' + feedbackItem + ' available.');
          }
        })
        .catch(error => {
          this.pagePaymentMethod = JSON.parse(`[{"id":0,"name":"Giro","key":"Giro"},{"id":1,"name":"Cheque","key":"Cheque"},{"id":2,"name":"Cash","key":"Cash"},{"id":3,"name":"Online","key":"Online"}]`);
          this.loadCarpark();
          // this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadCarpark() {
      let feedbackItem = 'car park data';
      this.$refs['carparkFilter'].setFilterLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pageCarpark = response.data;
          // this.$refs['carparkFilter'].setFilterDataWithValueIfFirstLoad(response.data, this.$route.query.carparkID);
          // this.$refs['carparkFilter'].setFilterDataWithValueIfFirstLoad([].concat({name: 'All Car Parks'}, response.data), this.$route.query.carparkID);
          this.setCarparInput();
        })
        .catch(error => {
          this.$refs['carparkFilter'].setFilterError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    setCarparInput() {
      let feedbackItem = 'car park license data'
      this.$refs['carparkFilter'].setFilterLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/license',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();

          let allParkingLicense = response.data;
          this.pageCarpark = this.pageCarpark.filter(k => {
            return allParkingLicense.find(j => j.carparkID === k.id)
          });

          this.showCalendar = true;
          // this.$refs['carparkFilter'].setFilterDataWithValueIfFirstLoad([].concat({name: 'All Car Parks'}, this.pageCarpark), this.$route.query.carparkID);
          this.$refs['carparkFilter'].setFilterDataWithValueIfFirstLoad(this.pageCarpark, this.$route.query.carparkID);
          this.loadCustomer();
        })
        .catch(error => {
          this.$refs['carparkFilter'].setFilterError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadCustomer() {
      let feedbackItem = 'customer data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          helper.SERVER_URL + '/api2/customer/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.pageCustomer = response.data;
          this.loadPasscardType();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadPasscardType() {
      let feedbackItem = 'passcard type data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          helper.SERVER_URL + '/api2/passtype/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pagePasstype = response.data;

          if(response.data && response.data.length > 0) {
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.loadCarparkSeasonSetting();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No passcard available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadCarparkSeasonSetting() {
      let url = helper.SERVER_URL + '/api2/carpark/' + this.$refs['carparkFilter'].filterValue + '/seasonSetting'

      let feedbackItem = 'car park season data';
      this.$refs['licenseFilter'].setFilterLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          
          this.pageCarparkSeason = response.data;
          let sst = ((response.data || [])[0] || {})['PercentSST']
          if (sst) {
            this.PARAM_MAP['sst'].text = (sst * 100) + '% SST (RM)'
          } else {
            this.PARAM_MAP['sst'].text = 'SST (RM)'
          }
          console.log(this.PARAM_MAP)

          if(response.data && response.data.length > 0) {
            this.loadLicense();
          }
        })
        .catch(error => {
          this.$refs['licenseFilter'].setFilterError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadLicense() {
      let url = helper.SERVER_URL + '/api2';
      if(this.$refs['carparkFilter'].filterValue) {
        url += '/carpark/' + this.$refs['carparkFilter'].filterValue;
      }
      url += '/license/';

      let feedbackItem = 'license data';
      this.$refs['licenseFilter'].setFilterLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          response.data.forEach(k => {
            k['_customer'] = this.pageCustomer.find(j => j.id === k.customerID);
            k['_carpark'] = this.pageCarpark.find(j => j.id === k.carparkID);
          });
          this.pageLicense = response.data;
          // this.$refs['licenseFilter'].setFilterDataWithValueIfFirstLoad(response.data, this.$route.query.licenseID);
          this.$refs['licenseFilter'].setFilterDataWithValueIfFirstLoad([].concat({name: 'All Parking Licenses'}, response.data), this.$route.query.licenseID);

          if(response.data && response.data.length > 0) {
            this.loadPasscard();
          }
        })
        .catch(error => {
          this.$refs['licenseFilter'].setFilterError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadPasscard() {
      let url = helper.SERVER_URL + '/api2';
      if(this.$refs['carparkFilter'].filterValue) {
        url += '/carpark/' + this.$refs['carparkFilter'].filterValue;
      }
      url += '/passcard/';

      let feedbackItem = 'passcard data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.pagePasscard = response.data;
          response.data.forEach(k => {
            let passtype = this.pagePasstype.find(j => j.id === k.passtypeID);
            k['option'] = passtype ? k['sku'] + ' - ' + passtype.name : k['sku'];
          });
          this.loadData();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadData() {
      let startDate = this.$refs['dateRangeFilter'].filterDateStart;
      let endDate = this.$refs['dateRangeFilter'].filterDateEnd;

      let feedbackItem = 'bill';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      let url = helper.SERVER_URL + '/api2/invoice?1=1';
      // url = helper.appendSearchQuery(url, this.$refs['pageSearch'].searchValue);
      // url = helper.appendPagingQuery(url, this.$refs['pageTable'].getCurrentPage());
      if(this.$refs['licenseFilter'].filterValue) {
        let license = this.pageLicense.find(k => helper.compareID(k.id, this.$refs['licenseFilter'].filterValue));
        url += '&customerID=' + license.customerID + '&carparkID=' + license.carparkID;
      } else if(this.$refs['carparkFilter'].filterValue) {
        url += '&carparkID=' + this.$refs['carparkFilter'].filterValue;
      }
      
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            response.data.sort((a, b) => b.createDate - a.createDate);
            // this.$refs['pageFeedback'].setFeedbackMessage();
            this.pageInvoice = response.data;

            this.pageInvoice = this.pageInvoice.filter(k => (k.paidDate || 0)  === 0 && (k.lockDate || 0)  === 0 && (k.voidDate || 0)  === 0 && (k.usedDate || 0)  === 0);
            this.pageInvoice = this.pageInvoice.filter(k => {
              try {
                k['_dataRef'] = JSON.parse(k['dataRef']);

                if(k['_dataRef'] && k['_dataRef']['billingDate']) {
                  let billingDate = helper.parseDateTime(k['_dataRef']['billingDate']);
                  if(!billingDate) {
                    return false;
                  }
                  if(billingDate.unix() < startDate.unix()) {
                    return false;
                  }
                  if(billingDate.unix() > endDate.unix()) {
                    return false;
                  }
                  return true;
                }
              } catch(e) {
              }

              return false;
            })

            this.loadInvoiceLease();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No ' + feedbackItem + ' available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadInvoiceLease() {
      let startDate = this.$refs['dateRangeFilter'].filterDateStart;
      let endDate = this.$refs['dateRangeFilter'].filterDateEnd;

      let feedbackItem = 'bill detail';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      let url = helper.SERVER_URL + '/api2/invoiceLease?1=1';
      if(this.$refs['licenseFilter'].filterValue) {
        url += '&licenseID=' + this.$refs['licenseFilter'].filterValue;
      }
      
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          // if(response.data && response.data.length > 0) {
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.pageInvoiceLease = response.data;
            this.processData();
          // } else {
          //   this.$refs['pageFeedback'].setFeedbackError('No ' + feedbackItem + ' available.');
          // }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },

    async processData() {
      let lastRow = {
        'jt-summary': true,
        'inclusive': 0,
        'sst': 0,
        'exclusive': 0,
      };
      
      for(let invoice of this.pageInvoice) {
        let customer = this.pageCustomer.find(j => helper.compareID(j.id, invoice.customerID)) || {};
        let license = this.pageLicense.find(j => j.customerID === invoice.customerID && j.carparkID === invoice.carparkID) || {};
        
        let customerID = customer['id'];
        if(!this.customerContactCache[customerID]) {
          let feedbackItem = 'bill customer detail';
          this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
          this.customerContactCache[customerID] = await this.$http
            .get(
              helper.SERVER_URL + '/api2/contact/' + customer.contact1,
              helper.createAxiosConfig()
            )
            .then(response => {
              this.$refs['pageFeedback'].setFeedbackMessage();
              let resultMeta = helper.processAxiosResponse(this, response);
              return helper.parseContact(response);
            })
            .catch(error => {
              this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading ', feedbackItem));
            });
        }
        let customerContact = this.customerContactCache[customerID];
        if(customerContact) {
          if(customer.isCompany) {
            invoice['customerEmail'] = customerContact['companyPICemail'] || '';
            invoice['customerPhone'] = customerContact['companyPICphone'] || '';
          } else {
            invoice['customerEmail'] = customerContact['personalEmail'] || '';
            invoice['customerPhone'] = customerContact['personalPhoneMobile'] || '';
          }
        }


        invoice['licenseID'] = license.id;
        invoice['parkinglicense'] = helper.plFormPLNum(license.licenseOperatorNum, invoice.carparkID);
        invoice['customerType'] = customer.isCompany ? 'Company' : 'Personal';
        invoice['customer'] = customer['name'];
        invoice['customerIdentity'] = customer['nationalID'];

        invoice['billNo'] = helper.plBillNum(invoice.creditNum || invoice.debitNum || invoice.invoiceNum, invoice.carparkID, invoice['type']);
        invoice['billDate'] = helper.formatDate(invoice['_dataRef']['billingDate']);
        invoice['billDescription'] = invoice['_dataRef']['description'];


        let invoiceID = invoice['id'];
        if(!this.invoiceLeaseCache[invoiceID]) {
          this.invoiceLeaseCache[invoiceID] = this.pageInvoiceLease.filter(j => j.invoiceID === invoiceID);
        }
        invoice['inclusive'] = 0;
        invoice['sst'] = 0;
        invoice['exclusive'] = 0;
        for(let invoiceLease of this.invoiceLeaseCache[invoiceID]) {
          invoice['inclusive'] += invoiceLease.inclusive;
          invoice['sst'] += invoiceLease.sst;
          invoice['exclusive'] += invoiceLease.exclusive;
        }

        if(helper.formatMoney(invoice['price']) !== helper.formatMoney(invoice['inclusive'])) {
          invoice['_dataRef']['description'] = invoice['_dataRef']['description'] + '(Error)';
        }

        if(invoice.billType === 'CN') {
          lastRow['inclusive'] -= invoice['inclusive'];
          lastRow['sst'] -= invoice['sst'];
          lastRow['exclusive'] -= invoice['exclusive'];

          invoice['inclusive'] = '-' + helper.formatMoney(invoice['inclusive']);
          invoice['sst'] = '-' + helper.formatMoney(invoice['sst']);
          invoice['exclusive'] = '-' + helper.formatMoney(invoice['exclusive']);
        } else {
          lastRow['inclusive'] += invoice['inclusive'];
          lastRow['sst'] += invoice['sst'];
          lastRow['exclusive'] += invoice['exclusive'];

          invoice['inclusive'] = helper.formatMoney(invoice['inclusive']);
          invoice['sst'] = helper.formatMoney(invoice['sst']);
          invoice['exclusive'] = helper.formatMoney(invoice['exclusive']);
        }
      }

      lastRow['inclusive'] = helper.formatMoney(lastRow['inclusive']);
      lastRow['sst'] = helper.formatMoney(lastRow['sst']);
      lastRow['exclusive'] = helper.formatMoney(lastRow['exclusive']);

      this.pageInvoice = this.pageInvoice.sort((a,b) => a.createDate - b.createDate);
      if(this.pageInvoice && this.pageInvoice.length > 0) {
        this.pageInvoice.push(lastRow);
        this.showExportCSV = true;
      }

      this.$refs['pageTable'].setTableData(this.pageInvoice);
    },

    onFilterCarparkChange(dataIndex) {
      this.showExportCSV = false;
      this.$refs['pageTable'].setCurrentPage(1);
      this.$refs['pageTable'].setTableData(this.pageInvoice = null);
      this.loadCarparkSeasonSetting();
    },
    onFilterLicenseChange(dataIndex) {
      this.showExportCSV = false;
      this.$refs['pageTable'].setCurrentPage(1);
      this.$refs['pageTable'].setTableData(this.pageInvoice = null);
      this.loadData();
    },
    onFilterDateChange(dataIndex) {
      this.showExportCSV = false;
      this.$refs['pageTable'].setCurrentPage(1);
      this.$refs['pageTable'].setTableData(this.pageInvoice = null);
      this.loadData();
    },
    onTablePageChange() {
      this.showExportCSV = false;
      this.loadData();
    },
    onSearchChange(dataIndex) {
      this.showExportCSV = false;
      this.$refs['pageTable'].setCurrentPage(1);
      this.$refs['pageTable'].setTableData(this.pageInvoice = null);
      this.loadData();
    },

    onCSVButtonClick() {
      let carpark = this.pageCarpark.find(k => helper.compareID(k.id, this.$refs['carparkFilter'].filterValue))
      let startDate = this.$refs['dateRangeFilter'].filterDateStart;
      let endDate = this.$refs['dateRangeFilter'].filterDateEnd;

      var header = [];
      if(carpark) {
        header.push('Car Park Code: ' + carpark.carparkCode)
        header.push('Car Park: ' + carpark.name)
      }
      header.push('Report: Outstanding Bills For The Month - ' + (startDate.month() + 1) + '/' + startDate.year())
      
      printCSV('#jt-table', `Report Outstanding Bills ${(startDate.month() + 1) + '/' + startDate.year()}`, header);
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Page/Report/PageReportOutstanding.vue